import React, { useState, useRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import "./AddNewPassword.css";
import { Container } from 'react-bootstrap';
import bluelock from "../../assets/images/svg/blueLock.svg";


const AddNewPassword = ({ url, translations }) => {
  const location = useLocation();
  const { email } = useParams();
  const navigate = useNavigate();
  const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);

  const handleCodeChange = (index, value) => {
    const updatedCode = [...verificationCode];
    updatedCode[index] = value.slice(0, 1);
    setVerificationCode(updatedCode);
    if (value !== '' && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('Text').slice(0, 6);
    const updatedCode = pastedData.split('').concat(Array(6 - pastedData.length).fill(''));
    setVerificationCode(updatedCode);
    const lastFilledIndex = updatedCode.findIndex((digit) => digit === '');
    inputRefs.current[lastFilledIndex >= 0 ? lastFilledIndex : 5].focus();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    setLoading(true);
    setError("");

    const digits = verificationCode.join('');
    const formData = new FormData();
    formData.append('key', digits);
    formData.append('new_password', newPassword);
    formData.append('confirm_password', confirmPassword);
    formData.append('cmd', 'frappe.core.doctype.user.user.update_password');
    formData.append('email', email);
    formData.append('logout_all_sessions', '1');

    try {
      const response = await axios.post(`${url}`, formData);
      console.log(response.data);
      navigate("/login");
    } catch (error) {
      setError("Failed to reset password. Please try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='auth'>
      <div className='check-email-container'>
        <Container>
          <div className='check-email-image'>
            <img src={bluelock} alt='Message' />
          </div>
          <h1 className='check-email-title'>Check your email</h1>
          <p className='check-email-para'>We sent a verification code to</p>
          <p className='check-email-para'>{email}</p>
          <form onSubmit={handleSubmit}>
            <div className='code-digits'>
              {verificationCode.map((digit, index) => (
                <input
                  key={index}
                  type='text'
                  className='code-digit'
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleCodeChange(index, e.target.value)}
                  onPaste={handlePaste}
                  ref={(ref) => (inputRefs.current[index] = ref)}
                  required
                />
              ))}
            </div>
            <input
              type='password'
              className='login-field password-field'
              placeholder="Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <input
              type='password'
              className='login-field password-field'
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            {error && <p className="error-text">{error}</p>}
            <button type="submit" className='login-submit' disabled={loading}>
              {loading ? "Processing..." : "Reset Password"}
            </button>
          </form>
        </Container>
      </div>
    </div>
  );
};

export default AddNewPassword;
